import { CopyIcon, LinkIcon, Search2Icon } from "@chakra-ui/icons";
import { Box, Button, Flex, Grid, Link, Spinner, Text } from "@chakra-ui/react";
import { Toast } from "components/toast";
import {
  ModalGerarLinkClt,
  openModalGerarLinkClt
} from "./modal-gerar-link-clt";
import { useEffect, useRef, useState } from "react";
import { requestLoop } from "components/atendimentos-components/atendimento-form/functions/consulta";
import apiDigitacao from "api/api-digitacao";
import { useAttendanceContext } from "contexts/attendance-context";
import { useApplicationContext } from "contexts/ApplicationContext";
import { FaClock } from "react-icons/fa";
import { CheckIcon2 } from "components/vectors/checked-box-icon";
import { ErrorIcon } from "components/vectors/error-icon";

interface CltLinkInfoProps {
  banco: string;
  cpf: string;
  status: string;
  codeRequest: string;
  link: string;
  dataAtualizacao: string;
  permissionStatus: string;
  permissionObservation: string;
  observacao: string;
}

export function GerarLinkClt({
  telaAtendimento
}: {
  telaAtendimento?: boolean;
}) {
  const [loadingGerarLinkClt, setLoadingGerarLinkClt] = useState(false);
  const [cltLinkInfo, setCltLinkInfo] = useState<CltLinkInfoProps>();
  const [cltStatusLinkInfo, setStatusCltLinkInfo] =
    useState<CltLinkInfoProps>();
  const [loadingStatusGerarLinkClt, setLoadingStatusGerarLinkClt] =
    useState(false);
  const { formControl, dispatch } = useAttendanceContext();
  const formValues = formControl.values;
  const { user } = useApplicationContext();
  const finalizeConsultationRef = useRef(false);

  const bancosClt =
    user.userData.customerId === 1
      ? [
          { name: "C6", value: "C6" },
          { name: "2S Consig", value: "TWO_S_CONSIG" },
          { name: "Pan", value: "PAN" }
        ]
      : user.userData.customerId === 2787 ||
          user.userData.parentCustomerId === 2787
        ? [
            { name: "2S Consig", value: "TWO_S_CONSIG" },
            { name: "Pan", value: "PAN" }
          ]
        : [{ name: "Pan", value: "PAN" }];

  const GETCltLink = async () => {
    return await apiDigitacao.get<CltLinkInfoProps>(
      `/api/gerar-autorizacao/${formValues.id}/link/consultar/${user.userData.customerId}`
    );
  };

  const GETStatusCltLink = async () => {
    return await apiDigitacao.get<CltLinkInfoProps>(
      `/api/gerar-autorizacao/${formValues.id}/status-link/consultar`
    );
  };

  const getLinkClt = async () => {
    setLoadingGerarLinkClt(true);
    setCltLinkInfo(undefined);
    requestLoop({
      promise: async () => {
        return await GETCltLink();
      },
      actionByStep(response) {
        setCltLinkInfo(response.data);
        if (finalizeConsultationRef.current) return { finalize: true };
        return {
          finalize:
            response.data.status === "FINISHED" ||
            response.data.status === "SYSTEM_ERROR"
        };
      },
      onFinish(response) {
        setLoadingGerarLinkClt(false);
      },
      onError(e) {
        if (
          [
            "autorizacao_not_found",
            "permission_not_found_hubbank",
            "erro_nao_mapeado"
          ].includes(e.response?.data?.message)
        )
          return { finalize: true };
        return { finalize: false };
      },
      delay: 3000
    });
  };

  const postLinkOrder = async () => {
    if (!cltLinkInfo?.cpf?.trim()) {
      Toast({
        title: "Atendimento sem CPF",
        description: "Preencha um cpf para o atendimento"
      });
      dispatch({
        type: "setInvalidField",
        payload: { fieldName: "cpf", action: "append" }
      });
      return;
    }
    setLoadingStatusGerarLinkClt(true);
    try {
      const { data } = await apiDigitacao.post(
        `/api/gerar-autorizacao/${formValues.id}/status-link`,
        { banco: cltLinkInfo.banco, cpf: cltLinkInfo.cpf }
      );
    } catch (e) {
      Toast({ title: "Erro ao verificar status de autorização." });
    } finally {
      setLoadingStatusGerarLinkClt(false);
    }
  };

  const getStatusLinkClt = async () => {
    setLoadingStatusGerarLinkClt(true);
    setStatusCltLinkInfo(undefined);
    requestLoop({
      promise: async () => {
        return await GETStatusCltLink();
      },
      actionByStep(response) {
        setStatusCltLinkInfo(response.data);
        if (finalizeConsultationRef.current) return { finalize: true };
        return { finalize: response.data.status === "FINISHED" };
      },
      onFinish(response) {
        setLoadingStatusGerarLinkClt(false);
      },
      onError(e) {
        return { finalize: true };
      },
      delay: 3000
    });
  };

  const mapStatusPermissionClt = (status: string) => {
    switch (status) {
      case null:
      case "WAITING_FOR_AUTHORIZATION":
        return {
          message: "Aguardando Autorização",
          color: "yellow.100",
          icon: <FaClock width="18px" height="18px" />
        };
      case "AUTHORIZED":
        return {
          message: "Autorizado",
          color: "green.100",
          icon: <CheckIcon2 />
        };
      case "NOT_AUTHORIZED":
        return {
          message: "Não Autorizado",
          color: "red.100",
          icon: <ErrorIcon width="18px" height="18px" />
        };
      default:
        return { message: "Não mapeado", color: "gray.100", icon: "" };
    }
  };

  useEffect(() => {
    async function asss() {
      await getLinkClt();
      getStatusLinkClt();
    }
    asss();
  }, []);

  useEffect(() => {
    finalizeConsultationRef.current = false;
    return () => {
      finalizeConsultationRef.current = true;
    };
  }, []);

  const linkLimit = telaAtendimento ? 60 : 30;

  return formValues.convenio === "CONSIGNADO_TRABALHADOR" ? (
    <>
      <Flex
        flexDir="column"
        borderBottom="1px solid #E8EAED"
        w="100%"
        px="25px"
        py="25px"
      >
        {[1, 2787].includes(user.userData.customerId!) ||
        user.userData.parentCustomerId === 2787 ? (
          <Flex alignItems="center">
            <Flex alignItems="center">
              {/* <Text>Link de Autorização:</Text> */}
              <Button
                size="xs"
                leftIcon={<LinkIcon />}
                // ml="10px"
                variant="outline"
                onClick={() =>
                  openModalGerarLinkClt({
                    onSendLinkOrder(banco) {
                      setStatusCltLinkInfo(undefined);
                      getLinkClt();
                    },
                    bancosClt
                  })
                }
                isLoading={loadingGerarLinkClt}
                loadingText="Gerando link de autorização"
              >
                Gerar link de autorização
              </Button>
            </Flex>
            <Flex>
              <Button
                size="xs"
                leftIcon={<Search2Icon />}
                ml="10px"
                // variant="outline"
                disabled={
                  loadingGerarLinkClt ||
                  cltLinkInfo?.link == null ||
                  cltLinkInfo.banco === "PAN"
                }
                onClick={async () => {
                  await postLinkOrder();
                  getStatusLinkClt();
                }}
                isLoading={loadingStatusGerarLinkClt}
                loadingText="Consultando Status do Link"
              >
                Consultar Status Link
              </Button>
            </Flex>
          </Flex>
        ) : null}
        {cltStatusLinkInfo ? (
          <Box
            bg={
              mapStatusPermissionClt(cltStatusLinkInfo.permissionStatus).color
            }
            my="10px"
            borderRadius="10px"
          >
            <Flex
              alignItems="center"
              justifyContent="center"
              height="50px"
              gap="6px"
            >
              <Text>
                {
                  mapStatusPermissionClt(cltStatusLinkInfo.permissionStatus)
                    .icon
                }
              </Text>
              <Text>Status: </Text>
              <Text fontWeight="semibold">
                {
                  mapStatusPermissionClt(cltStatusLinkInfo.permissionStatus)
                    .message
                }
              </Text>
            </Flex>
          </Box>
        ) : null}
        {cltLinkInfo ? (
          <>
            <Text my="8px" fontWeight="medium">
              Histórico de Links Gerados
            </Text>
            <Grid
              templateColumns="1fr auto"
              w="100%"
              minH="40px"
              borderRadius="10px"
              bg="gray.100"
              alignItems="center"
              px="8px"
              gap="12px"
            >
              <Flex alignItems="center" minW={0} gap="8px">
                <Text mr="8px" fontWeight="semibold" whiteSpace="nowrap">
                  Banco{" "}
                  {
                    bancosClt.find(({ value }) => value === cltLinkInfo.banco)
                      ?.name
                  }
                </Text>
                {!loadingGerarLinkClt ? null : (
                  <Spinner w="20px" h="20px" ml="12px" />
                )}
                {cltLinkInfo.link ? (
                  <Link href={cltLinkInfo.link} target="_blank" isTruncated>
                    {cltLinkInfo.link.length > linkLimit
                      ? cltLinkInfo.link.slice(0, linkLimit) + "..."
                      : cltLinkInfo.link}
                  </Link>
                ) : (
                  <Text textColor="red.500">{cltLinkInfo.observacao}</Text>
                )}
              </Flex>
              <Flex alignItems="center" justifyContent="flex-end">
                <Text mr="10px" color="gray.500" whiteSpace="nowrap">
                  {cltLinkInfo.dataAtualizacao}
                </Text>
                {cltLinkInfo.link ? (
                  <Button
                    leftIcon={<CopyIcon />}
                    size="xs"
                    isDisabled={loadingGerarLinkClt}
                    onClick={() => {
                      navigator.clipboard.writeText(cltLinkInfo.link);
                      Toast({
                        title: "Link copiado para area de transferencia",
                        status: "success"
                      });
                    }}
                  >
                    Copiar
                  </Button>
                ) : null}
              </Flex>
            </Grid>
          </>
        ) : null}
      </Flex>
      <ModalGerarLinkClt />
    </>
  ) : null;
}
